import { endOfDay } from 'date-fns/endOfDay';
import { formatISO9075 } from 'date-fns/formatISO9075';
import { startOfDay } from 'date-fns/startOfDay';

import {
  CreateCampaignFormStep01Values,
  RestoredStep01Data,
} from '@features/campaigns/builder/containers/FormPages/FormPages.types';
import { CampaignDetails, CampaignMediaType, CampaignMediaTypes } from '@features/campaigns/shared/types/campaign.ts';
import { CreateCampaignStep01Payload } from '@features/campaigns/shared/types/campaignBuilderTypes.ts';

export function createCampaignStep01DTO(
  formValues: CreateCampaignFormStep01Values,
  mediaType: CampaignMediaType = CampaignMediaTypes.CTV,
): CreateCampaignStep01Payload {
  const { advertiserId, brandId, name, isAgencyCommissionGross, isNameAutoGenerated } = formValues;
  const dateRange = formValues.dateRange || [];

  return {
    advertiserId,
    brandId,
    name,
    isNameAutoGenerated,
    isAgencyCommissionGross,
    budget: formValues.budget.toString(),
    startDate: formatISO9075(dateRange[0], { representation: 'date' }),
    endDate: formatISO9075(dateRange[1], { representation: 'date' }),
    mediaType,
  };
}

export function restoreStep01DataDTO(data: CampaignDetails): RestoredStep01Data {
  const startDate = startOfDay(new Date(data.startDate));
  const endDate = endOfDay(new Date(data.endDate));

  return {
    id: data.id,
    advertiserId: data.advertiser.id,
    advertiserName: data.advertiser.name,
    advertiserCode: data.advertiser.code,
    brandId: data.brand.id,
    brandName: data.brand.name,
    brandCode: data.brand.code,
    name: data.name,
    isAgencyCommissionGross: data.isAgencyCommissionGross,
    dateRange: [startDate, endDate],
    budget: data.budget,
    isNameAutoGenerated: data.isNameAutoGenerated,
    campaignType: data.type,
    country: data.country,
    status: data.status,
    createdBy: data.createdBy,
    invalidSections: data.invalidSections,
  };
}

export function restoreStep01FormValues(data: RestoredStep01Data): CreateCampaignFormStep01Values {
  return {
    advertiserId: data.advertiserId,
    brandId: data.brandId,
    name: data.name,
    isAgencyCommissionGross: data.isAgencyCommissionGross,
    dateRange: data.dateRange,
    budget: data.budget,
    isNameAutoGenerated: data.isNameAutoGenerated,
  };
}
